module.exports = "/assets/data/020d3af97cc3c59d24004b345026e582-OX7.data.json";